/* tslint:disable */
/* eslint-disable */
/**
 * Tardek API Endpoints
 * This Is a documentation for T1 Tardek API Endpoints. <br />
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: info@bitweb.ee
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Required fields map
 * @export
 * @enum {string}
 */

export enum DeclarationFieldErrorResponseRequirement {
    Required = 'REQUIRED',
    Optional = 'OPTIONAL',
    Forbidden = 'FORBIDDEN'
}



